import React from 'react';
import style from './EmptyReportCard.module.css';


const EmptyReportCard = ({ title, desc }) => (
    <div className={style.card}>
        <strong className={style.title}>{title}</strong>
        {desc && <p className={style.desc}>{desc}</p>}
    </div>
);

export default EmptyReportCard;
